import { render, staticRenderFns } from "./effectPopup.vue?vue&type=template&id=6b9d8e04&"
import script from "./effectPopup.ts?vue&type=script&lang=js&"
export * from "./effectPopup.ts?vue&type=script&lang=js&"
import style0 from "./effectPopup.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports